import { PriceUnits } from "../../../../lib/const/priceUnits";
import { RateModes } from "../../../../lib/const/rateModes";
import { DictionaryDto } from "../../../../lib/interfaces";

export const getAllowedPriceUnits = (
  priceUnits: DictionaryDto<PriceUnits>[],
  isPacketTariff: boolean,
  rateModeId?: RateModes
): DictionaryDto<PriceUnits>[] => {
  const { PIECE, IN_FACT, DAY, MONTH, QUARTER, HALF_YEAR, YEAR } = PriceUnits;
  if (isPacketTariff) {
    return priceUnits.filter(({ id }) => id === PIECE);
  }
  if (!rateModeId) {
    return priceUnits;
  }
  const allowed = {
    [RateModes.ONE_TIME]: [IN_FACT],
    [RateModes.PERIODIC]: [DAY, MONTH, QUARTER, HALF_YEAR, YEAR],
    [RateModes.TRAFFIC]: [PIECE],
  };
  const allowedIds = allowed?.[rateModeId];
  if (allowedIds) {
    return priceUnits.filter(({ id }) => allowedIds.includes(id));
  }
  return priceUnits;
};
